import { render, staticRenderFns } from "./SendersDetailModal.vue?vue&type=template&id=77f30b98&scoped=true"
import script from "./SendersDetailModal.vue?vue&type=script&lang=js"
export * from "./SendersDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SendersDetailModal.vue?vue&type=style&index=0&id=77f30b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f30b98",
  null
  
)

export default component.exports